import {CircularProgress} from '@mui/material';
import AppButton from '../../../../../components/common/AppButton';
import AppDialog from '../../../../../components/common/AppDialog';
import {SVG} from '../../../../../constants/assetLists';

const EXCEL_OPTIONS = {
  title: 'בחרו את מה ברצונכם לעשות',
  btns: [
    {title: 'להחליף את הרשומה הכפולה', value: 'replace'},
    {title: 'לדלג על הרשומה הכפולה', value: 'skip'},
    {title: 'לעצור את ההעתקה ולשאול שוב', value: 'hold'},
  ],
};

const EXCEL_DUPLICATE_OPTIONS = {
  title: 'הרשומה כבר קיימת במערכת, מה ברצונך לעשות?',
  btns: [
    {title: 'להחליף את הרשומה הכפולה', value: 'replace'},
    {title: 'לדלג על הרשומה הכפולה', value: 'skip'},
  ],
};

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  isDuplicateErr: boolean;
  isLoading: boolean;
  onOptionClick: (value: string) => void;
};

function ImportExcelOptionsDialog({
  open,
  onClose,
  title = '',
  isDuplicateErr,
  isLoading,
  onOptionClick,
}: Props) {
  const options = isDuplicateErr ? EXCEL_DUPLICATE_OPTIONS : EXCEL_OPTIONS;

  return (
    <AppDialog showModel={open} showCloseIcon={false} onClose={onClose}>
      <div className="flex flex-col gap-10 px-[32px]">
        {isLoading ? (
          <div className="flex flex-col items-center gap-3">
            <CircularProgress />
            <p className="m-0 text-[24px] text-[#1D1B20]">{title}</p>
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            <img
              src={SVG.excelGreenLgIcon}
              alt="icon"
              className="w-[48px] h-[48px] object-contain mx-auto"
            />
            <p className="m-0 text-[24px] text-[#1D1B20] text-center">
              {title}
            </p>

            <div className="flex flex-col gap-2">
              <p className="m-0 text-[14px] text-darkerGray text-center">
                {options.title}
              </p>

              {options.btns.map((item: any, index: number) => (
                <AppButton
                  key={index}
                  className="justify-center"
                  onClick={() => onOptionClick(item.value)}>
                  {item.title}
                </AppButton>
              ))}
            </div>
          </div>
        )}

        <div className="flex justify-content-end">
          <button
            className="text-[20px] font-medium text-darkGreen hover:opacity-60 transition-opacity duration-200"
            onClick={onClose}>
            ביטול
          </button>
        </div>
      </div>
    </AppDialog>
  );
}

export default ImportExcelOptionsDialog;
